"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ERROR = void 0;
exports.DEFAULT_ERROR = {
    provider: "error",
    cryptoAmount: 0,
    fiatAmount: 0,
    rate: 0,
    isError: true,
    isRequestedCurrency: true,
    paymentOptions: [],
    fiatCode: "none",
};
//# sourceMappingURL=BaseBuyProvider.js.map